export default "__VITE_ASSET__Nf5Yn3$V__"